/*HEADER*/
var _ = require('lodash');
window.$ = window.jQuery = require('jquery');

require('materialize-css');
require('sweetalert');

require('./views/index');
require('./views/login');
require('./views/random');